import { render, staticRenderFns } from "./smartControlTask_page.vue?vue&type=template&id=691cc655&scoped=true"
import script from "./smartControlTask_page.vue?vue&type=script&lang=js"
export * from "./smartControlTask_page.vue?vue&type=script&lang=js"
import style0 from "./smartControlTask_page.vue?vue&type=style&index=0&id=691cc655&lang=scss&scoped=true"
import style1 from "./smartControlTask_page.vue?vue&type=style&index=1&id=691cc655&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691cc655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('691cc655')) {
      api.createRecord('691cc655', component.options)
    } else {
      api.reload('691cc655', component.options)
    }
    module.hot.accept("./smartControlTask_page.vue?vue&type=template&id=691cc655&scoped=true", function () {
      api.rerender('691cc655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/smartControl/smartControlTask_page.vue"
export default component.exports